export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/writing_legends-babe2efc2cb58a5fd81a467b9f9a45e9.svg";